import type { SvgProps } from "react-native-svg";
import { SearchableSectionList } from "./FilterView/SearchableSectionList";
import OnboardingLayout from "./OnboardingLayout";

type Props = {
	handleNext: () => void;
	selectedExamId?: string;
	handleSelectExam: (examId: string) => void;
	filteredSections: {
		title: string;
		data: {
			name: string;
			id: string;
		}[];
	}[];
	searchValue: string;
	setSearchValue: (searchValue: string) => void;
	categoryName?: string;
	selectedExamName?: string;
	emptySearchResultSvg?: React.FC<SvgProps>;
	cta?: string;
	showSearch?: boolean;
};
const ChooseExamScreen = ({
	handleNext,
	selectedExamId,
	handleSelectExam,
	filteredSections,
	searchValue,
	setSearchValue,
	categoryName,
	selectedExamName,
	emptySearchResultSvg,
	cta = "Continue",
	showSearch = false,
}: Props) => {
	return (
		<OnboardingLayout
			onPrimaryPress={handleNext}
			disabled={!selectedExamId}
			primaryActionLabel={cta}
			// useScroll={false}
			selectedItemText={selectedExamName}
			selectedItemLabel="Selected exam"
			onSearchChange={showSearch ? setSearchValue : undefined}
			searchbarProps={{
				value: searchValue,
				placeholder: categoryName
					? `Search in ${categoryName}`
					: "Search exams...",
			}}
		>
			<SearchableSectionList
				sections={filteredSections}
				showCurrentExamChip={false}
				handleSelectItem={handleSelectExam}
				selectedItemId={selectedExamId}
				initSelectedItemId={selectedExamId}
				emptySearchResultSvg={emptySearchResultSvg}
				handleClearSearch={() => setSearchValue("")}
			/>
		</OnboardingLayout>
	);
};

export default ChooseExamScreen;
